import styled from "@emotion/styled";
import Divider from "@mui/material/Divider";

export const LegalLinksWrapper = styled.div(({ theme }) => ({
	display: "flex",
	gap: 12,
	padding: "12px 0",
	width: "fit-content",
	flexWrap: "wrap",
	marginLeft: "20px",
	[theme.breakpoints.down("md")]: {
		flexDirection: "column",
		padding: "20px",
		alignItems: "center",
		width: "100%",
		margin: 0,
		boxSizing: "border-box",
		hr: {
			display: "none"
		},
		textAlign: "center"
	}
}));

export const LegalLinksDivider = styled(Divider)(({ theme }) => ({
	[theme.breakpoints.down("md")]: {
		display: "none"
	}
}));
